import { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Event } from '../../types/event';
import { events } from '../../api/events';
import { EventDetails } from './components/EventDetails';
import { useLoader } from '../../contexts/LoaderContext';
import { useAlert } from '../../contexts/AlertContext';
import './EventDetailsPage.scss';

export const EventDetailsPage = () => {
  const { id } = useParams<{ id: string }>();
  const [event, setEvent] = useState<Event | null>(null);
  const { showLoader, hideLoader } = useLoader();
  const { showAlert } = useAlert();

  useEffect(() => {
    const fetchEvent = async () => {
      if (!id) return;

      try {
        showLoader();
        const data = await events.getById(id);
        setEvent(data);
      } catch (error) {
        showAlert('Failed to load event', 'error');
      } finally {
        hideLoader();
      }
    };

    fetchEvent();
  }, [id, showLoader, hideLoader, showAlert]);

  if (!event) {
    return null;
  }

  return (
    <div className="event-details-page">
      <div className="breadcrumbs">
        <Link to="/events">Events</Link>
        <span>/</span>
        <span>{event.name}</span>
      </div>
      <EventDetails event={event} />
    </div>
  );
};
